import { render, staticRenderFns } from "./CLayoutTemplate.vue?vue&type=template&id=bd0fd25e&"
import script from "./CLayoutTemplate.vue?vue&type=script&lang=ts&"
export * from "./CLayoutTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports